<app-add-idd-training-certificate
  [iddTrainingObject]="iddTrainingObject"
  [dialogRef]="dialogRef"
></app-add-idd-training-certificate>
